/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Title_ColInputs */

const en_admin_roles_title_col = /** @type {(inputs: Admin_Roles_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Admin_Roles_Title_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_title_col = /** @type {((inputs?: Admin_Roles_Title_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Title_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_title_col(inputs)
});
export { admin_roles_title_col as "admin.roles.title_col" }